<!--  Only Large and Normal Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth > 1230'>
    <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div  (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex"></div>
      <div class="flex-60">
          <div class="bulletin-header-utilities flex-container">
              <div class="flex">
                  <a [routerLink]='["/tool-report"]' [queryParams]="{page:page}"><i class="material-icons">arrow_back</i></a>
              </div>
              <div class="flex">
                <div class="align-right">
                  <i class="material-icons" style="float: right;" (click)='printBulletin()'>print</i>
                </div>
              </div>
            </div>
            <div class="bmw-report-detail-content" #toolReportContent>
        <div class="bmw-report-title print-title">{{report?.description}}</div>
        <div style="display: flex;">
          <div style="flex: 0 0 45%;">
            <div class="bmw-report-image">
              <img src='mount/tool/{{report?.documentFileName}}'>
            </div>
            <div class="bmw-report-notes-label">
              Notes:
            </div>
            <div class="bmw-report-notes">
              {{report?.notes}}
            </div>
          </div>
          <div class="flex: 0 0 10%;"></div>
          <div class="flex: 0 0 45%;">
            <div class="bmw-report-details">
              <div class="bmw-report-detail-label">Order Part Number</div>
              <div class="bmw-report-detail">{{report?.orderPartNumber}}</div>
              <div class="bmw-report-detail-label">Part Number</div>
              <div class="bmw-report-detail">{{report?.partNumber}}</div>
              <div class="bmw-report-detail-label">Brands</div>
              <div class="bmw-report-detail">{{report?.make.makeName}}</div>
              <div class="bmw-report-detail-label">Series</div>
              <div class="bmw-report-detail">{{reportSeries}}</div>
              <div class="bmw-report-detail-label">SIB</div>
              <div class="bmw-report-detail">{{report?.bulletinDisplayNumber}}</div>
              <div class="bmw-report-detail-label">Description</div>
              <div class="bmw-report-detail">{{report?.description}}</div>
              <div class="bmw-report-detail-label">Autoships</div>
              <div class="bmw-report-detail">{{report?.autoShip}}</div>
              <!-- div class="bmw-report-detail-label">Toolboard Location</div -->
              <div class="bmw-report-detail">{{report?.location}}</div>
              <div class="bmw-report-detail-label">External MFR Warranty</div>
              <div class="bmw-report-detail">{{report?.externalMfrgToolWarranty}}</div>
            </div>
          </div>
        </div>
        </div>
      </div>
      <div style="flex: 1 1 0%;"></div>
    </div>
  </div>
</div>
<!-- Only iPadPro and Medium size Desktop HTML5 Goes here... -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div  (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
      <div class="flex"></div>
       <div class="bulletin-header-utilities flex-container">
              <div class="flex">
                  <a [routerLink]='["/tool-report"]'><i class="material-icons">arrow_back</i></a>
              </div>
              <div class="flex">
                <div class="align-right">
                  <i class="material-icons" style="float: right;" (click)='printBulletin()'>print</i>
                </div>
              </div>
            </div>
      <div class="bmw-report-detail-content flex-70">
        <div class="bmw-report-title">{{report?.description}}</div>
        <div class="flex-container column">
          <div class="flex-50">
            <div class="bmw-report-image">
              <img src='mount/tool/{{report?.documentFileName}}'>
            </div>
            <div class="bmw-report-notes-label">
              Notes:
            </div>
            <div class="bmw-report-notes">
              {{report?.notes}}
            </div>
          </div>
          <div class="flex-50">
            <div class="bmw-report-details">
              <div class="bmw-report-detail-label">Order Part Number</div>
              <div class="bmw-report-detail">{{report?.orderPartNumber}}</div>
              <div class="bmw-report-detail-label">Part Number</div>
              <div class="bmw-report-detail">{{report?.partNumber}}</div>
              <div class="bmw-report-detail-label">Brands</div>
              <div class="bmw-report-detail">{{report?.make.makeName}}</div>
              <div class="bmw-report-detail-label">Series</div>
              <div class="bmw-report-detail">{{reportSeries}}</div>
              <div class="bmw-report-detail-label">SIB</div>
              <div class="bmw-report-detail">{{report?.bulletinDisplayNumber}}</div>
              <div class="bmw-report-detail-label">Description</div>
              <div class="bmw-report-detail">{{report?.description}}</div>
              <div class="bmw-report-detail-label">Autoships</div>
              <div class="bmw-report-detail">{{report?.autoShip}}</div>
              <!-- div class="bmw-report-detail-label">Toolboard Location</div -->
              <div class="bmw-report-detail">{{report?.location}}</div>
              <div class="bmw-report-detail-label">External MFR Warranty</div>
              <div class="bmw-report-detail">{{report?.externalMfrgToolWarranty}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
  </div>
</div>

<!--  Only Tablet or iPad HTML5 Goes here... -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container">
        <div class="bulletin-header-utilities flex-container">
            <div class="flex">
                <a [routerLink]='["/tool-report"]'><i class="material-icons">arrow_back</i></a>
            </div>
            <div class="flex">
              <div class="align-right">
                <i class="material-icons" style="float: right;" (click)='printBulletin()'>print</i>
              </div>
            </div>
          </div>

      <div class="bmw-report-detail-content sm">
        <div class="bmw-report-title">{{report?.description}}</div>
        <div class="flex-container column">
          <div class="flex-50">
            <div class="bmw-report-image">
              <img src='mount/tool/{{report?.documentFileName}}'>
            </div>
            <div class="bmw-report-notes-label">
              Notes:
            </div>
            <div class="bmw-report-notes">
              {{report?.notes}}
            </div>
          </div>
          <div class="flex-50">
            <div class="bmw-report-details">
              <div class="bmw-report-detail-label">Order Part Number</div>
              <div class="bmw-report-detail">{{report?.orderPartNumber}}</div>
              <div class="bmw-report-detail-label">Part Number</div>
              <div class="bmw-report-detail">{{report?.partNumber}}</div>
              <div class="bmw-report-detail-label">Brands</div>
              <div class="bmw-report-detail">{{report?.make.makeName}}</div>
              <div class="bmw-report-detail-label">Series</div>
              <div class="bmw-report-detail">{{reportSeries}}</div>
              <div class="bmw-report-detail-label">SIB</div>
              <div class="bmw-report-detail">{{report?.bulletinDisplayNumber}}</div>
              <div class="bmw-report-detail-label">Description</div>
              <div class="bmw-report-detail">{{report?.description}}</div>
              <div class="bmw-report-detail-label">Autoships</div>
              <div class="bmw-report-detail">{{report?.autoShip}}</div>
              <!--  div class="bmw-report-detail-label">Toolboard Location</div -->
              <div class="bmw-report-detail">{{report?.location}}</div>
              <div class="bmw-report-detail-label">External MFR Warranty</div>
              <div class="bmw-report-detail">{{report?.externalMfrgToolWarranty}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Only Mobile hTML5 goes here... -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
      <div class="bulletin-header-utilities flex-container">
          <div class="flex">
              <a [routerLink]='["/tool-report"]'><i class="material-icons">arrow_back</i></a>
          </div>
          <div class="flex">
            <div class="align-right">
              <i class="material-icons" style="float: right;" (click)='printBulletin()'>print</i>
            </div>
          </div>
        </div>
        
    <div class="bmw-report-detail-content xs">
      <div class="bmw-report-title">{{report?.description}}</div>
      <div class="bmw-report-image xs">
        <img src='mount/tool/{{report?.documentFileName}}'>
      </div>
      <div>
        <div class="bmw-report-detail-label">Order Part Number</div>
        <div class="bmw-report-detail">{{report?.orderPartNumber}}</div>
        <div class="bmw-report-detail-label">Part Number</div>
        <div class="bmw-report-detail">{{report?.partNumber}}</div>
        <div class="bmw-report-detail-label">Brands</div>
        <div class="bmw-report-detail">{{report?.make.makeName}}</div>
        <div class="bmw-report-detail-label">Series</div>
        <div class="bmw-report-detail">{{reportSeries}}</div>
        <div class="bmw-report-detail-label">SIB</div>
        <div class="bmw-report-detail">{{report?.bulletinDisplayNumber}}</div>
        <div class="bmw-report-detail-label">Description</div>
        <div class="bmw-report-detail">{{report?.description}}</div>
        <div class="bmw-report-detail-label">Autoships</div>
        <div class="bmw-report-detail">{{report?.autoShip}}</div>
        <!-- div class="bmw-report-detail-label">Toolboard Location</div -->
        <div class="bmw-report-detail">{{report?.location}}</div>
        <div class="bmw-report-detail-label">External MFR Warranty</div>
        <div class="bmw-report-detail">{{report?.externalMfrgToolWarranty}}</div>
      </div>
      <div class="bmw-report-notes-label">
        Notes:
      </div>
      <div class="bmw-report-notes">
        {{report?.notes}}
      </div>
    </div>
  </div>
</div>